<template>
  <el-dialog :title="$t('searchToSendTitle')" :visible="isShowDialog" @close="closePopup()" width="600px">
    <span id="modal-body">
      <el-form ref="form" label-width="150px" style="width: 500px">
        <el-form-item :label="$t('searchByKeyword')">
          <el-input v-model="keyword" @input="isTyping = true" :placeholder="$t('placeholder')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('filterType')">
          <el-checkbox v-model="isFilterMarket" label="market" @change="onChangeCheckboxData"> {{ $t('market') }} </el-checkbox>
          <el-checkbox v-model="isFilterAgentType" label="agent" @change="onChangeCheckboxData"> {{ $t('agentType') }} </el-checkbox>
          <el-checkbox v-model="isFilterAgent" label="agent" @change="onChangeCheckboxData"> {{ $t('agent') }} </el-checkbox>
        </el-form-item>
      </el-form>
      <div>
        <el-table
          id="popup-search-to-send-list-table"
          :data="getListDataSource()"
          header-row-class-name="table-header-color"
          style="width: 100%"
          v-loading="isTyping">
          <el-table-column
            prop="type"
            :label="$t('type')">
              <template slot-scope="scope">{{ getTypeName(scope.row.type) }}</template>
          </el-table-column>
          <el-table-column
            :label="$t('name')">
            <template slot-scope="scope">{{ scope.row.name }}</template>
          </el-table-column>
          <el-table-column align="right">
            <template slot-scope="scope">
              <el-button v-if="isAdded(scope.row) === false"
                         type="warning" size="small"
                         icon="el-icon-plus"
                         @click="onAddButtonClick(scope.row)">
                {{ $t('add') }}
              </el-button>
              <el-button v-if="isAdded(scope.row) === true"
                         type="success" size="small"
                         @click="onRemoveButtonClick(scope.row)">
                <i class="el-icon-remove minus-icon" style="color: red"></i>
                {{ $t('added') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 10px">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="filterData().length"
            :page-size="pageSize"
            :current-page="currentPage"
            @current-change="changePage">
          </el-pagination>
        </div>
      </div>
    </span>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSaveButtonClick()">{{ $t('save') }} ({{ getNumberOfSelectedItem() }})</el-button>
      <el-button type="default" @click="closePopup">{{ $t('cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { STATUS } from '@/configs/constant'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import i18nMessages from '@/translations/Email/ManageEmail/components/PopupSearchToSendComponent.i18n'
import { filterDataByKeyword, getDataOnPaging, adjustCurrentPage } from '@/services/general-service'
import { debounce } from 'lodash'

export default {
  name: 'PopupSearchToSendComponent',
  i18n: { messages: i18nMessages },
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    agentList: {
      type: Array,
      default: function () {
        return []
      }
    },
    agentTypeList: {
      type: Array,
      default: function () {
        return []
      }
    },
    marketList: {
      type: Array,
      default: function () {
        return []
      }
    },
    selectedMarketList: {
      type: Array,
      default: function () {
        return []
      }
    },
    selectedAgentTypeList: {
      type: Array,
      default: function () {
        return []
      }
    },
    selectedAgentList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      STATUS,
      keyword: '',
      currentPage: 1,
      pageSize: 5,
      isFilterMarket: true,
      isFilterAgent: true,
      isFilterAgentType: true,
      isShowDialog: false,
      isTyping: false,
      sourceDataList: []
    }
  },
  watch: {
    visible: function (newValue) {
      this.isShowDialog = newValue
    },
    keyword: debounce(function () {
      this.isTyping = false
    }, 500),
    isTyping: function (value) {
      if (!value) {
        this.filterData()
      }
    }
  },
  created: async function () {
    this._prepareListDataSource()
  },
  methods: {
    getListDataSource: function () {
      const filteredList = this.filterData()
      this.currentPage = adjustCurrentPage(filteredList.length, this.currentPage, this.pageSize)

      const resultList = getDataOnPaging(filteredList, this.currentPage, this.pageSize)
      return resultList
    },
    getTypeName: function (type) {
      switch (type) {
        case 'market':
          return this.$t('market')
        case 'agent':
          return this.$t('agent')
        case 'agentType':
          return this.$t('agentType')
        default:
          return 'N/A'
      }
    },
    filterData: function () {
      const searchKeys = ['name']
      const filteredList = filterDataByKeyword(this.sourceDataList, this.keyword, searchKeys)

      return filteredList
    },
    changePage: function (page) {
      this.currentPage = page
    },
    onChangeCheckboxData: function () {
      this.sourceDataList = []
      this._prepareListDataSource()
    },
    onAddButtonClick: function (row) {
      switch (row.type) {
        case 'market':
          this.selectedMarketList.push(row)
          break
        case 'agent':
          this.selectedAgentList.push(row)
          break
        case 'agentType':
          this.selectedAgentTypeList.push(row)
          break
      }
    },
    onRemoveButtonClick: function (row) {
      switch (row.type) {
        case 'market':
          const removeMarketIndex = this._findRemoveIndex(this.selectedMarketList, row.id)
          this.selectedMarketList.splice(removeMarketIndex, 1)
          break
        case 'agentType':
          const removeAgentTypeIndex = this._findRemoveIndex(this.selectedAgentTypeList, row.id)
          this.selectedAgentTypeList.splice(removeAgentTypeIndex, 1)
          break
        case 'agent':
          const removeAgentIndex = this._findRemoveIndex(this.selectedAgentList, row.id)
          this.selectedAgentList.splice(removeAgentIndex, 1)
          break
      }
    },
    _findRemoveIndex: function (list, removeId) {
      for (let index in list) {
        if (list[index].id === removeId) {
          return index
        }
      }
    },
    isAdded: function (row) {
      switch (row.type) {
        case 'market':
          return (this.selectedMarketList.find(market => market.id === row.id) !== undefined)
        case 'agent':
          return (this.selectedAgentList.find(agent => agent.id === row.id) !== undefined)
        case 'agentType':
          return (this.selectedAgentTypeList.find(agentType => agentType.id === row.id) !== undefined)
      }
    },
    onSaveButtonClick: function () {
      this.keyword = ''
      this.isShowDialog = false

      const result = {
        marketList: this.selectedMarketList,
        agentList: this.selectedAgentList,
        agentTypeList: this.selectedAgentTypeList
      }
      this.$emit('onSaveChange', result)
    },
    closePopup: function () {
      this.keyword = ''
      this.isShowDialog = false
      this.$emit('onClose')
    },
    getNumberOfSelectedItem: function () {
      return this.selectedAgentList.length + this.selectedMarketList.length + this.selectedAgentTypeList.length
    },
    _prepareListDataSource: function () {
      if (this.isFilterMarket === true) {
        this._prepareMarketListDataSource()
      }

      if (this.isFilterAgentType === true) {
        this._prepareAgentTypeListDataSource()
      }

      if (this.isFilterAgent === true) {
        this._prepareAgentListDataSource()
      }
    },
    _prepareAgentListDataSource: function () {
      this.agentList.forEach((agent) => {
        const agentData = {
          type: 'agent',
          id: agent.id,
          name: agent.name
        }

        this.sourceDataList.push(agentData)
      })
    },
    _prepareAgentTypeListDataSource: function () {
      this.agentTypeList.forEach((agentType) => {
        const agentTypeData = {
          type: 'agentType',
          id: agentType.id,
          name: agentType.name
        }

        this.sourceDataList.push(agentTypeData)
      })
    },
    _prepareMarketListDataSource: function () {
      this.marketList.forEach((market) => {
        const marketData = {
          type: 'market',
          id: market.id,
          name: market.name
        }

        this.sourceDataList.push(marketData)
      })
    }
  }
}
</script>

<style scoped>
  .el-form > div {
    text-align: left;
  }
  .minus-icon {
    position:absolute;
    margin-top: -16px;
    margin-left: 46px;
  }
</style>
